export default __webpack_public_path__ + "assets/images/answer-after-b3dbf893.png";